import { TranslateService } from '@ngx-translate/core';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'translateFieldName'
})
export class TranslateFieldNamePipe implements PipeTransform {

  constructor(private translateService: TranslateService) { }

  /**
   * 欄位名稱的轉換，通常會用在 table 取值的欄位設定上
   * 在語系的切換時，根據把欄位名稱換成語系相對應的欄位名稱
   * 以部門為例，資料欄位應該包含 deptNameTw、deptNameCn、deptNameUs
   *
   * @param value 預設的欄位名稱
   * @param fieldName 要取的欄位名稱 ( 不需要加語系名稱，例如: deptName )
   * @returns 相對應語系的欄位名稱
   */
  transform(value: string, fieldName: string): string {
    let currentLangFieldName: string = '';
    const currentLang = this.translateService.currentLang.split('-')[1];
    currentLangFieldName = fieldName.concat(currentLang[0].toUpperCase()).concat(currentLang.substring(1).toLowerCase());
    return currentLangFieldName ? currentLangFieldName : value;
  }
}
